export { createSvgIcon as default } from '@material-ui/core/utils';


//////////////////
// WEBPACK FOOTER
// /home/ig_comp_doc/sandbox-manager-v3/node_modules/@material-ui/icons/esm/utils/createSvgIcon.js
// module id = 1
// module chunks = 0